import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=25bb5506&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=ts"
export * from "./Receipt.vue?vue&type=script&lang=ts"
import style0 from "./Receipt.vue?vue&type=style&index=0&id=25bb5506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb5506",
  null
  
)

export default component.exports